@if (collapsible()) {
  <button (click)="toggleCollapse()" class="card__header" type="button">
    <ng-content select="[card-header]" />
    <span class="card__toggle">
      @if (collapsed) {
        <i class="fa-solid fa-chevron-down"></i>
      } @else {
        <i class="fa-solid fa-chevron-up"></i>
      }
    </span>
  </button>

  <div class="card__collapsible">
    <div [hidden]="collapsed" class="card__content">
      <ng-content select="[card-collapsible]" />
    </div>
  </div>
} @else {
  <ng-content />
}
